var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-pane active",attrs:{"id":"tab2"}},[_c('BigFileAttachment',{attrs:{"metaData":_vm.metaData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }